import type { DivisionItem } from "@/scott/ui/blocks/divisions/divisions";
import {
  adaptTeaserItem,
  type TeaserItemInput,
} from "@/services/contentful/components/TeaserItem/teaser-item.adapter";

const DIVISION_TRANSFORM = ["ar_2:3", "c_fill", "g_auto"];

export interface DivisionNavigationInput {
  __typename: "DivisionNavigation";
  sys?: { id: string; locale?: string | null };
  internalName?: string | null;
  ariaLabel?: string | null;
  divisionsCollection?: {
    items: Array<TeaserItemInput | null>;
  } | null;
}

export type DivisionNavigationData = {
  ariaLabel?: string;
  divisions: DivisionItem[];
};

/**
 * Adapts an optional global assembly. Null or unresolved localized content is
 * intentionally represented as no navigation so the footer can fail closed.
 *
 * @param basePath The active market's `/{country}/{lang}`, which internal page
 * links are placed below.
 */
export function adaptDivisionNavigation(
  assembly: DivisionNavigationInput | null | undefined,
  basePath: string
): DivisionNavigationData | null {
  if (!Array.isArray(assembly?.divisionsCollection?.items)) {
    return null;
  }

  const assemblyId = assembly.sys?.id ?? assembly.internalName ?? "unknown";
  const divisions = assembly.divisionsCollection.items
    .filter((division): division is TeaserItemInput => division !== null)
    .map((division, index) =>
      adaptTeaserItem(division, {
        basePath,
        index,
        parentLabel: `Division Navigation "${assemblyId}"`,
        transform: DIVISION_TRANSFORM,
      })
    );

  if (divisions.length === 0) {
    return null;
  }

  return {
    ariaLabel: assembly.ariaLabel?.trim() || undefined,
    divisions,
  };
}
